import React, {PureComponent} from 'react'
import clampJs from "clamp-js"
import cn from 'classnames'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import {getScreenWidth} from "../../selectors/content";
import flow from 'lodash/flow'

class Summary extends PureComponent {

    _setElement = (ref) => this._element = ref;

    componentDidMount() {
        this._updateClamp();
    }

    componentDidUpdate() {
        this._updateClamp();
    }

    _updateClamp = () => {
        const {clamp} = this.props;
        if(!this._element || !clamp) return;

        const supportsNativeClamp = typeof(this._element.style.webkitLineClamp) !== 'undefined';

        // BUG IN CHROME WHEN YOU RESIZE THE WINDOW IT DOES NOT RECALCULATE THE LINE CLAMP
        //if(supportsNativeClamp) ((element) => element.style.webkitLineClamp = '')(this._element.firstChild || this._element);
        //defer(() => {
            //if(!this._element || !clamp) return;
            clampJs(this._element.firstChild || this._element, {
                useNativeClamp: true,
                clamp: supportsNativeClamp ? clamp : clamp + 1 // bug in clamp-js that truncates it to one less line in ie & firefox
            })
        //});
    }

    render() {
        const {classes, className, summary, clamp} = this.props;
        return <div className={cn(classes.container, {clamp}, className)} ref={this._setElement} dangerouslySetInnerHTML={{__html: summary}} onClick={this._updateClamp}></div>

    }
}

const mapStateToProps = (state) => {
    return {
        screenWidth: getScreenWidth(state)
    }
}


export default flow(
    connect(mapStateToProps),
    injectSheet((theme) => ({
        container: {}
    }))
)(Summary)




// WEBPACK FOOTER //
// ./src/components/Widgets/Summary.js